"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DefaultTooltip = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Wrapper = _styledComponents.default.span.withConfig({
  displayName: "DefaultTooltip__Wrapper",
  componentId: "sc-8agdis-0"
})(["line-height:1.5;text-align:center;white-space:pre-line;"]);

var DefaultTooltip = function DefaultTooltip(_ref) {
  var tooltip = _ref.tooltip;
  return /*#__PURE__*/_react.default.createElement(Wrapper, null, tooltip);
};

exports.DefaultTooltip = DefaultTooltip;
DefaultTooltip.propTypes = {
  tooltip: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.node]).isRequired
};